module.exports = __webpack_public_path__ + "img/logo-wrios.f8aa6ff5.svg";